var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon is-large has-text-danger is-clickable",on:{"click":_vm.toggle}},[_c('i',{staticClass:"mdi mdi-36px",class:_vm.active? 'mdi-circle':'mdi-circle-outline'})])
}
var staticRenderFns = []

export { render, staticRenderFns }